import React from 'react';
import { Box } from "@mui/material";

const WrapTableEdit = ({children}) => {
	return (
		<>
			<Box
				sx={{
					width: "100%",
					minHeight: "50vh",
					"& .MuiDataGrid-columnHeadersInner": {
						backgroundColor: "#E6E6E6",
					},
					"& .MuiBox-root": {
						flex: 1,
						display: "flex",
					},
					"& .MuiSvgIcon-root": {
						width: "0.9375rem",
					},
					"& .MuiDataGrid-columnHeaderTitle": {
						fontSize: "0.729rem",
						fontWeight: 700,
						textTransform: "uppercase",
					},
					"& .MuiDataGrid-cell": {
						padding: "0px 10px !important",
					},
					"& .MuiDataGrid-cellContent": {
						fontSize: "0.83rem",
					},
					"& .MuiDataGrid-row--editing": {
						boxShadow: "none !important",
					},
					"& button[aria-label='Update']": {
						borderRadius: "5px",
					},
					"& .MuiDataGrid-root": {
						border: 0,
					},
					"& .MuiDataGrid-main": {
						border: "0.052rem solid rgba(224, 224, 224, 1)",
						marginTop: "30px",
					},
					"& .css-1b74o31-MuiInputBase-root-MuiDataGrid-editInputCell input":
						{
							padding: "10px 16px",
							backgroundColor: "#fafafa",
							border: "1px solid #f0f0f0",
						},
					"& .Mui-error": {
						backgroundColor: "red",
						color: "red",
					},
				}}>
				{children}
			</Box>
		</>
	);
};

export default WrapTableEdit;